module.exports = __webpack_public_path__ + "img/1-Fauna.34fefe36.jpg";